import { HoudiniClient, cache } from '$houdini'
import sessionStore, { getSession } from 'stores/session'
import buildApiUrl from 'utility/build-api-url'

let session = getSession()
sessionStore.subscribe(newSession => {
	session = newSession
	// Clear cache on logout
	if (!session?.authToken) {
		cache.reset()
	}
})

function hasExtensionsNotes(error: unknown): error is { extensions: { notes: string } } {
	return (
		typeof error === 'object' &&
		error !== null &&
		'extensions' in error &&
		(error as { extensions: { notes: string } }).extensions.notes !== undefined
	)
}

const client = new HoudiniClient({
	url: buildApiUrl().apiURL,
	fetchParams(ctx) {
		return {
			headers: {
				'auth-token': session.authToken ?? '',
				'apollographql-client-name': 'EnterpriseWeb',
				'apollographql-client-version': '__buildVersion__',
				'Content-Type': 'application/json',
				'x-apollo-operation-name': ctx.document.name,
			},
		}
	},
	// We're used to errors throwing with our custom api fetch, so let's keep that behavior
	// TODO, maybe we can add errors to a more permanent log here?
	throwOnError: {
		operations: ['all'],
		error: errors => {
			if (errors.length > 1) {
				console.error('houdini errors', errors)
			} else {
				console.error('houdini error', errors[0])
			}
			let message = errors[0].message
			if (hasExtensionsNotes(errors[0])) {
				message += `\r\nAdvanced Details:\r\n${errors[0].extensions.notes}`
			}
			throw new Error(message, { cause: errors[0] })
		},
	},
})
export default client
